import React from 'react'
import ProfessionalChartLoader from '../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader'
import ChartErrorView from '../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView'
import { EChartsPresenter } from '../../../common/components/molecule/EChartsView'
import { EChartsData } from '../../../common/components/molecule/EChartsView/EChartsView'
import { BarPoint } from '../types/joulyDailyTypes'
import { useMinigridNamesByUuid } from '../service/useMinigridNamesByUuid'

type Props = {
  data: BarPoint[]
  loading?: boolean
  error?: Error | null
}

const TITLE = 'Appareils actifs par minigrid'

export default function LocationsBarPresenter({ data, loading, error }: Props) {
  const { resolveName } = useMinigridNamesByUuid()

  if (loading) {
    return <ProfessionalChartLoader metricName={TITLE} />
  }

  if (error) {
    return <ChartErrorView metricName={TITLE} error={error} />
  }

  if (!data || data.length === 0) {
    return (
      <EChartsPresenter
        data={[]}
        title={TITLE}
        type="bar"
        height={400}
        showDataZoom={false}
      />
    )
  }

  const chartData: EChartsData[] = data.map((pt) => ({
    name: resolveName(pt.uuid),
    value: pt.count,
  }))

  return (
    <EChartsPresenter
      data={chartData}
      title={TITLE}
      type="bar"
      height={400}
      xAxisLabel="Minigrid"
      yAxisLabel="Appareils actifs"
      showLegend={false}
      showTooltip={true}
      showDataZoom={false}
    />
  )
}
